import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// const supportedLocales = ['ja', 'zh-CN']
// const defaultLocale = supportedLocales.includes(localStorage.locale) ? localStorage.locale : 'ja'

// NOTE: 暫定的に多言語化をクローズ
const defaultLocale = 'ja'

const ja = Object.assign(
  require('@/locales/ja.json'),
  require('@/locales/top/ja.json'),
  require('@/locales/room/ja.json'),
  require('@/locales/userPolicy/ja.json'),
  require('@/locales/privacyPolicy/ja.json'),
  require('@/locales/paidVersionUserPolicy/ja.json'),
  require('@/locales/paidVersionPrivacyPolicy/ja.json')
)

const zhCN = Object.assign(
  require('@/locales/zh-CN.json'),
  require('@/locales/top/zh-CN.json'),
  require('@/locales/room/zh-CN.json'),
  require('@/locales/userPolicy/zh-CN.json'),
  require('@/locales/privacyPolicy/zh-CN.json')
)

const i18n = new VueI18n({
  locale: defaultLocale,
  messages: {
    'ja': ja,
    'zh-CN': zhCN
  }
})

export default i18n
